@defer (on immediate) {
<app-header />
<router-outlet />
<app-footer />


@if (cookieContainer()) {
<div class="cookieWrapper">
    <div class="cookieContainer">
        <div class="cookieText">
            This website uses cookies. By using this website, you agree to the use of cookies. For more information,
            click
            <a [routerLink]="['/cookies']">here.</a>
        </div>
        <div class="cookieButton">
            <div (click)="acceptCookies()">OK</div>
        </div>
    </div>
</div>
}

} @placeholder (minimum 50ms) {
<!-- <p>Placeholder content</p> -->
}
<!-- <button (click)="throwTestError()">Test Sentry Error</button> -->